import { render, staticRenderFns } from "./UsersRoleFilter.vue?vue&type=template&id=5dd08478&scoped=true&"
import script from "./UsersRoleFilter.vue?vue&type=script&lang=js&"
export * from "./UsersRoleFilter.vue?vue&type=script&lang=js&"
import style0 from "./UsersRoleFilter.vue?vue&type=style&index=0&id=5dd08478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd08478",
  null
  
)

export default component.exports